import type { FC, ReactNode, HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  variant?: "default" | "elevated";
  padding?: "none" | "sm" | "md" | "lg";
  hover?: boolean;
}

export const Card: FC<CardProps> = ({
  children,
  variant = "default",
  padding = "md",
  hover = false,
  className = "",
  ...props
}) => {
  const baseStyles = "card rounded-lg transition-all duration-200";

  const variants = {
    default: "bg-[var(--color-surface)] border border-[var(--color-border)]",
    elevated: "bg-[var(--color-elevated)] border border-[var(--color-border)]",
  };

  const paddings = {
    none: "",
    sm: "p-4",
    md: "p-6",
    lg: "p-8",
  };

  const hoverClass = hover ? "card--hover" : "";

  return (
    <div
      className={`${baseStyles} ${variants[variant]} ${paddings[padding]} ${hoverClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
